import { render, staticRenderFns } from "./DelegatesBio.vue?vue&type=template&id=61824b0c"
import script from "./DelegatesBio.vue?vue&type=script&lang=js"
export * from "./DelegatesBio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports